import { WSButton, WSButtons, WSText } from "@wingspanhq/fe-component-library";
import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";
import React from "react";
import { SetupFlowRouteComponentProps } from "../../../components/SetupFlow/SetupFlow";
import { SetupLayout } from "../../../components/SetupFlow/SetupFlowLayout";
import { useCreateAccount } from "../../../query/users/mutations";
import { useMemberPlaidLink } from "../../../utils/usePlaidLink";

export const AddStandardPayoutMethodType: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const [createAccount, createAccountMeta] = useCreateAccount();

  const plaidHandler = useMemberPlaidLink({
    onSuccess: async (publicToken: string) => {
      const accounts = (await createAccount({
        publicToken,
        status: AccountStatus.Pending
      })) as IAccount[];

      if (accounts) {
        onNext();

        return {
          success: true,
          data: accounts
        };
      } else {
        return {
          success: false
        };
      }
    }
  });

  return (
    <SetupLayout title="Connect your bank account" onBack={onBack}>
      <WSButtons forceFullWidth>
        <WSButton.Secondary
          onClick={() => {
            onNext({ manual: true });
          }}
        >
          Manually enter account info
        </WSButton.Secondary>
        <WSButton.Secondary
          onClick={() => {
            plaidHandler.open();
          }}
          loading={createAccountMeta.isLoading}
          name="connectWithPlaid"
        >
          Connect with Plaid
        </WSButton.Secondary>
      </WSButtons>

      <WSText.Label mt="M" color="grey600">
        Wingspan partners with Plaid to verify your bank account. Plaid is
        certified in internationally-recognized security standards, like ISO
        27001, ISO 27701, and is SSAE18 SOC 2 compliant.
      </WSText.Label>
    </SetupLayout>
  );
};
